import { useField } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Message, Icon, Table, Checkbox } from "semantic-ui-react";

import { amountPrecision } from "constants/formConstants";

const SellReceiptTable = ({ sData, setSData }) => {
	const { allProducts: products } = useSelector((state) => state.products);
	const [totalValue, setTotalValue] = useState(0);
	const parseProduct = (id) =>
		products.find((item) => item._id.toString() === id);

	const [{ value: paid }, , { setValue: setPaid }] = useField("paid");

	useEffect(() => {
		if (sData.length) {
			const total = [];
			for (const dt of sData)
				total.push(parseFloat(dt.rate) * parseFloat(dt.quantity));
			setTotalValue(
				total.reduce((tot, val) => tot + val).toFixed(amountPrecision)
			);
		}
	}, [sData]);

	return !sData?.length ? (
		<Message style={{ textAlign: "center" }}>
			<Icon name="attention" size="huge" color="grey" />
			<p>Nothing to show yet. Add record.</p>
		</Message>
	) : (
		<Table>
			<Table.Header>
				<Table.Row>
					<Table.HeaderCell>Particular(s)</Table.HeaderCell>
					<Table.HeaderCell textAlign="right">Qty</Table.HeaderCell>
					<Table.HeaderCell textAlign="right">Rate</Table.HeaderCell>
					<Table.HeaderCell textAlign="right">
						Amount
					</Table.HeaderCell>
					<Table.HeaderCell />
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{sData.map((item) => (
					<Table.Row key={item.productId}>
						<Table.Cell>
							{parseProduct(item.productId)?.name ??
								"Name could not be parsed."}
						</Table.Cell>
						<Table.Cell textAlign="right">
							<b>{item.quantity}</b>/-
						</Table.Cell>
						<Table.Cell textAlign="right">
							<b>Rs.{item.rate}</b>/-
						</Table.Cell>
						<Table.Cell textAlign="right">
							<b>
								Rs.
								{parseFloat(item.rate) *
									parseFloat(item.quantity)}
							</b>
							/-
						</Table.Cell>
						<Table.Cell textAlign="center">
							<Icon
								link
								name="trash"
								circular
								color="red"
								onClick={() =>
									setSData(
										sData.filter(
											(tm) =>
												tm.productId.toString() !==
												item.productId.toString()
										)
									)
								}
							/>
						</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
			<Table.Footer style={{ background: "#f7f7f7" }}>
				<Table.Row>
					<Table.Cell textAlign="right">Total</Table.Cell>
					<Table.Cell />
					<Table.Cell />
					<Table.Cell textAlign="right">
						{" "}
						<b>Rs.{totalValue}</b>/-
					</Table.Cell>
					<Table.Cell />
				</Table.Row>
				<Table.Row>
					<Table.Cell />
					<Table.Cell />
					<Table.Cell textAlign="right">
						<span
							style={{
								color: !!paid ? "green" : "red",
							}}
						>
							Paid?
						</span>
					</Table.Cell>
					<Table.Cell textAlign="right">
						<Checkbox
							checked={!!paid}
							toggle
							onClick={() => setPaid(!!!paid)}
						/>
					</Table.Cell>
					<Table.Cell />
				</Table.Row>
			</Table.Footer>
		</Table>
	);
};

export default SellReceiptTable;
